// Runs first (side effects / singletons live here)
import "./lib/Api.js";

// Then boot your app
import "./index.jsx";
